import React from 'react';
import img1 from '../../images/Screenshot (64).png'
import img4 from '../../images/Screenshot (96).png'
import img3 from '../../images/Screenshot (97).png'
import img2 from '../../images/Screenshot (98).png'
import img5 from '../../images/Screenshot (99).png'

const Passcomments = () => {
    return (
        <div className='md:m-10 m-4'>
            <div className='md:w-1/2 mx-auto md:my-16'>
                <h1 className='text-4xl font-bold mb-5'>Description</h1>
                <p className='text-lg'>This is a review website. People can add a review about the services they took, they can also add new products to get reviews. They must create an account to add reviews or products. Anyone can read some blogs without having to create an account.
                    For front-end I have used JavaScript, React JS, Firebase authentication, Tailwind and Daisy UI for mobile and tablet responsiveness, For back-end I used Express.js, Node.js and MongoDB for crud operation. And for hoisting I used Firebase hoisting..</p>
                <a href="https://pass-comments.web.app/" target='blank'>
                    <button className='px-6 py-2 rounded-3xl mt-6 mb-10 md:mt-10 git-button'>Website</button>
                </a>
            </div>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
                <img src={img1} alt="" className='rounded-xl shadow-xl' />
                <img src={img2} alt="" className='rounded-xl shadow-xl' />
                <img src={img3} alt="" className='rounded-xl shadow-xl' />
                <img src={img4} alt="" className='rounded-xl shadow-xl' />
                <img src={img5} alt="" className='rounded-xl shadow-xl' />
            </div>
        </div>
    );
};

export default Passcomments;